// @codekit-prepend "navigation.js"
// @codekit-prepend "skip-link-focus-fix.js"

// End: Libraries

// Captcha
function onSubmit(token) {
	console.log("Testing Captcha")
	// document.getElementById("form__submit").submit();
	submitCustomerInfo();
}

function csfSubmit(token) {

	console.log("Submitting CS Form")
	// document.getElementById("customerserviceform").submit();

	// console.log("submitCustomerInfo:")
	let csf_reason = document.getElementById("csf_reason");
	let csfFullName = document.getElementById("csf_fullname");
	let csfEmail = document.getElementById("csf_email");
	let csfPhone = document.getElementById("csf_phone");
	let csfMessage = document.getElementById("csf_message");
	let csfAcknowledgement = document.getElementById("csf_acknowledgement");

    
	// Validate First Name
	var csf_reasonFlag = true;
	// var cur_url = window.location.href;

	if (csf_reason.value == 'Please select an option') {
		csf_reason.classList.add("err")
		csf_reasonFlag = false;
	} else {
		csf_reason.classList.remove("err");
		csf_reasonFlag = true;
	}

	// Validate First Name
	var csfFullNameFlag = true;
	// var cur_url = window.location.href;

	if (csfFullName.value == '') {
		csfFullName.classList.add("err")
		csfFullNameFlag = false;
	} else {
		csfFullName.classList.remove("err");
		csfFullNameFlag = true;
	}

	// Validate First Name
	var csfEmailFlag = true;
	// var cur_url = window.location.href;

	if (csfEmail.value == '') {
		csfEmail.classList.add("err")
		csfEmailFlag = false;
	} else {
		csfEmail.classList.remove("err");
		csfEmailFlag = true;
	}
	
	var csfPhoneFlag = true;
	
	if (phoneValidation(csfPhone.value) == false) {
		csfPhone.classList.add("err")
		csfPhoneFlag = false;
	} else {
		// form__phone.removeClass('err');
		csfPhone.classList.remove("err")
		csfPhoneFlag = true;
	}

	// var form__email = jQuery('#form__email');
	var csfMessageFlag = true;

	if (csfMessage.value == '') {
		csfMessage.classList.add("err")
		csfMessageFlag = false;
	} else {
		csfMessage.classList.remove("err")
		csfMessageFlag = true;
	}


	var csfAcknowledgementFlag = true;

    if (csfAcknowledgement.checked == false) {
        csfAcknowledgement.classList.add("err")
        csfAcknowledgementFlag = false;
    } else {
        csfAcknowledgement.classList.remove("err");
        csfAcknowledgementFlag = true;
    }




	if (csf_reasonFlag && csfFullNameFlag && csfEmailFlag && csfPhoneFlag && csfMessageFlag && csfAcknowledgementFlag) { 
		
		jQuery('.form-error-messaging').removeClass('active');

		jQuery.ajax({
			method: 'post',
			url: '/wp-content/themes/walker-legal-brand/forms/send-customer-message.php',
			data: {
				'csf_reason': jQuery("#csf_reason").val(),
				'csf_fullname': jQuery("#csf_fullname").val(),
				'csf_email': jQuery("#csf_email").val(),
				'csf_phone': jQuery("#csf_phone").val(),
				'csf_message': jQuery("#csf_message").val(),
				'csf_permission': jQuery("#csf_permission").val(),
			},
			success: function (response) {
				console.log("Message Sent")
			},
			error: function (response) {
				jQuery('.form-error-messaging').html('There has been an error. Please Try Again or call us for faster service.');
				jQuery('.form-error-messaging').addClass('active');
				console.log("API/Sending Error")
			}
		}).done(function() {
			window.location.href = "/thank-you-feedback/";            
		})   
	
	} else {
		// console.log("Validation Error");
		jQuery('.form-error-messaging').addClass('active');
	}


	

}


// Start: Practice Area Slide 
jQuery(".practice-area-title-bar").click(function(e) {
	jQuery(".practice-areas-accordion-wrapper > .practice-areas-accordion").removeClass('open');
    jQuery(e.target.nextElementSibling).slideToggle("fast");    
    e.srcElement.classList.toggle('open')
    e.target.parentElement.classList.toggle('open')
});
// End: Practice Area Slide 

// Start: Faqs Page 
jQuery(".question__q").click(function(e) {
    jQuery(e.target.nextElementSibling).slideToggle("fast");    
    e.srcElement.classList.toggle('open')
    e.target.parentElement.classList.toggle('open')
});
// End: Faqs Page 

// Start: Activate Header Stripe on Scroll, Remove at top of page
jQuery(window).on('scroll', function () {
    const headerElement = jQuery(".header");
    var scrollDistance = jQuery(window).scrollTop();    
    // console.log(scrollDistance);

	if (scrollDistance > 0 ) {
        headerElement.addClass('active')
    } else {
        headerElement.removeClass('active');
    }
}).scroll();  
// Start: Activate Header Stripe on Scroll, Remove at top of page


// Start: Practice Area Page Jump Link Functionality
if (jQuery("body").hasClass("page-template-page-practice-area")) {

    // Menu Click Handler Function
    jQuery('.link-element[href*=#]').bind('click', function(e) {

        console.log(e);
        var linkElement = this;

        e.preventDefault(); // prevent hard jump, the default behavior

        var target = jQuery(this).attr("href"); // Set the target as variable

    //     // perform animated scrolling by getting top-position of target-element and set it as scroll target
        jQuery('html, body').animate({
                scrollTop: jQuery(this).offset().top - 215
        }, 300, function() {
                location.hash = target; //attach the hash (#jumptarget) to the pageurl
        });
        return false;
    }).scroll();    

    var practiceAreaAnchors = jQuery(window).on('scroll', function () {
        var scrollDistance = jQuery(window).scrollTop();    
        const headerElement = jQuery(".header");
		const headerTotal = headerElement.height();
        const hero = jQuery(".page-hero");
        const sidebarWrapper = jQuery(".main-sidebar__wrapper");
        const fixedHeaderStack = headerElement.height() + hero.height();
		var screenRelativeTop =  jQuery("#schedule").offset().top - (window.scrollY || window.pageYOffset || document.body.scrollTop);
        
        if (scrollDistance > (fixedHeaderStack - headerTotal)){

			sidebarWrapper.addClass('fixed')
			if (screenRelativeTop < headerTotal) {
				sidebarWrapper.removeClass('fixed')
			}

        } else {
			sidebarWrapper.removeClass('fixed');
            jQuery('.link-element.active').removeClass('active');
        }
        
        // // Assign active class to nav links while scolling
        jQuery('h2').each(function(i) {

			if (jQuery(this).position().top - 120 <= scrollDistance) {
                jQuery('.link-element.active').removeClass('active');
                jQuery('.link-element').eq(i).addClass('active');
            }

        });


        jQuery('.page-section').each(function(i) {
            
        });

    }).scroll();  

};
// End: Practice Area Page Jump Link Functionality

// Start: Flip Cards
jQuery('.flip-link').click(function() {
    jQuery(this).closest(".single-profile").toggleClass("flipped");
});
// End: Flip Cards

// Start: Document Ready Functions
jQuery(document).ready(function(){

    // Start: Toggle Mobile Menu
    jQuery('.hamburger-menu').click(function(){
        var scroll = jQuery(window).scrollTop();

        // const footerCallButton = jQuery(".footer--call");

        if(jQuery('.header').hasClass('active') == false){
            jQuery('.header').addClass('active');
            // jQuery$("body").css("overflow", "hidden");

            // footerCallButton.addClass('inactive');
        }else{
            jQuery("body").css("overflow", "auto");

            if (scroll < 0) {
                jQuery('.header').removeClass('active')
                // jQuery("body").removeClass('noscroll');
                // footerCallButton.removeClass('inactive');
            }
        }
        jQuery('.header__menu').toggleClass('active');
        // jQuery('.header__bottom').toggleClass('actived');
        jQuery(this).toggleClass('active');
    })
    // End: Toggle Mobile Menu	

    // Start: Mobile Navigation Sub Menu
    var menuToggle = jQuery(".header__menu .menu > .menu-item.menu-item-has-children > .sub-menu > .menu-item > a");

    menuToggle.click(function(e){
        e.preventDefault;

		if (window.innerWidth < 991) {
			var sibingChildMenu = jQuery(this).next();
			jQuery(this).toggleClass("hover");
			sibingChildMenu.slideToggle();;
			sibingChildMenu.toggleClass("hover");
		}
    });
	// End: Mobile Navigation Sub Menu

    // Start: Mobile Navigation Sub Menu Click Function
    jQuery('.menu-item-has-children').each(function(){
        this.onclick = function() {
            var childSubMenu = this.find(">.sub-menu");
            jQuery(childSubMenu).removeClass('hover');
        },
        function () {
            jQuery('.header__menu').removeClass('hover');
        }
    });
	// End: Mobile Navigation Sub Menu Click Function

    // Start: Testimonial Slider
    if (jQuery('#testimonial-carousel').length > 0 ) {

        jQuery('#testimonial-carousel').slick({
            centerMode: true,
            infinite: true,
            arrows: false,
            focusOnSelect: true,
            dots:true,
            centerPadding: '0',
            slidesToShow: 3,
			adaptiveHeight: false,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  arrows: false,
                  centerMode: true,
                  centerPadding: '0',
                  slidesToShow: 1
                }
              },
              {
                breakpoint: 480,
                settings: {
                  arrows: false,
                  centerMode: true,
                  centerPadding: '0',
                  slidesToShow: 1
                }
              }
            ]
        });

    };
	// End: Testimonial Slider



    // Start: Attorney Slider
    if (jQuery('#attorneys-wrapper').length > 0) {

        jQuery('#attorneys-wrapper').slick({
            // centerMode: true,
            infinite: true,
            arrows: false,
            dots:true,
            slidesToShow: 3,
            slidesToScroll: 3,

            responsive: [
                {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
                },
                {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '1.5rem',
                    slidesToShow: 1
                }
                }
            ]
        });

    };
    // End: Attorney Slider

    // Start: Form Slider
    if (jQuery('#form-wrapper').length > 0) {

        jQuery('#form-wrapper').slick({
			dots: true,
			arrows: false,
			infinite: false,
			speed: 250,
			centerMode: false,
			swipe: false
        });

    };
    // End: Form Slider

	// Start: Homepage Practice Area Slider with Nav
	if (jQuery('.homepage__practice-areas').length > 0 && window.innerWidth > 767) {

		jQuery('.practice-area-content').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			asNavFor: '.practice-area-selection'
		  });

		  jQuery('.practice-area-selection').slick({
			slidesToShow: 6,
			asNavFor: '.practice-area-content',
			dots: false,
			centerMode: true,
			centerPadding: 0,
			focusOnSelect: true
		  });
	
	};
	// End: Homepage Practice Area Slider with Nav

	// Start: Init Lead Form
	// Identify Form Element
	var formVar =  document.getElementById('form__contact');

	// If form exists, add event listeners
	if (typeof(formVar) != 'undefined' && formVar != null) {
		
		document.getElementById("form__contact").addEventListener('submit', (e) => {
			e.preventDefault();
			// submitLeadForm()
		});
	}
	// Start: Init Lead Form

	// Show Call footer button when scrolled homepage
	if (jQuery("body").hasClass("home")) {
		console.log('homepage');
		jQuery(window).on('scroll', function () {
			var scrollDistance = jQuery(window).scrollTop();    
	
			// console.log(scroll);
			const helpStepsSection = jQuery(".homepage__problem-solved");
			const footerCallButton = jQuery(".footer--call");
	
			if (helpStepsSection.position().top <= scrollDistance) {
				footerCallButton.removeClass('inactive')
			} else {
				footerCallButton.addClass('inactive')
			}
	
		}).scroll();  
	}


})
// End: Document Ready Function